import { IAction, ActionType } from "../actions/actiontype";
import * as _ from 'lodash';
import { updateArray } from "../../../helpers/index";

export interface FormErrorModel {
    errorList: Array<string>;
};

export const defaultFormErrorModel: FormErrorModel = {
    errorList: []
};

export default function formErrorReducer(state: FormErrorModel = defaultFormErrorModel, action: IAction) {
    switch (action.type) {
        case ActionType.ADD_FORM_ERROR: {
            const value = action.value as string;
            const newArray = [...state.errorList.slice(0, state.errorList.length), value];

            return _.assign({}, state, {
                errorList: newArray
            });
        }

        case ActionType.CLEAR_FORM_ERRORS: {
            return _.assign({}, state, { errorList: [] });
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./app/camp-sign-up/redux/reducers/form-error-reducer.ts